import type { CSSProperties } from 'react';
import type { CustomActionResponse } from '@troia-v3/types';

/**
 * Estilos de apresentação compartilhados entre ToolCard (Cards) e ToolListItem
 * (Lista). Method badge = tokens semânticos de tema (subtle bg + fg legível),
 * NUNCA cores hardcoded — segue o mesmo sistema do shared Badge.
 */
export type HttpMethod = CustomActionResponse['endpoint']['method'];

export const ALL_METHODS: HttpMethod[] = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'];

/** Fundo/foreground do badge de método HTTP, via CSS variables de tema. */
export const methodBadgeStyle = (method: string): CSSProperties => {
  switch (method) {
    case 'GET':
      return { backgroundColor: 'var(--theme-success-subtle)', color: 'var(--theme-success-fg)' };
    case 'POST':
      return { backgroundColor: 'var(--theme-info-subtle)', color: 'var(--theme-info-fg)' };
    case 'PUT':
      return { backgroundColor: 'var(--theme-warning-subtle)', color: 'var(--theme-warning-fg)' };
    case 'PATCH':
      return { backgroundColor: 'var(--theme-primary-background)', color: 'var(--theme-primary)' };
    case 'DELETE':
      return { backgroundColor: 'var(--theme-error-subtle)', color: 'var(--theme-error-fg)' };
    default:
      return { backgroundColor: 'var(--theme-surface-sunken)', color: 'var(--theme-muted-text)' };
  }
};
